<template>
<!-- 论文预览页 -->
  <div class="paperPreview">
    <p v-show="state" class="invalid">该页面为预览效果，短期内将会失效</p>
    <div v-if="state" class="content">
      <div class="lift">
        <p>
          <img src="@/assets/img/qietu/kongxin.png" alt="">
          <span>收藏</span>
        </p>
        <p>
          <img src="@/assets/img/details/download.png" alt="">
          <span>下载</span>
        </p>
        <p>
          <img src="@/assets/img/details/onlineReading.png" alt="">
          <span>在线阅读</span>
        </p>
        <p>
          <img src="@/assets/img/details/share.png" alt="">
          <span>分享</span>
        </p>
      </div>
      <div>
        <div class="centre">
          <p class="h" v-html="previewList.title">{{previewList.title}}</p>
          <ul>
              <li>
                  <span class="liLeft">作者:</span>
                  <span class="liRight">
                    <span style="margin-right: 10px;" v-for="(item,index) in assembleAutherUnitInfo.authors" :key="index">
                      <span>{{item.name}}</span>
                      <span style="position: relative;top: -8px;right: 0;font-size: 12px;margin-right:2px;" v-for="i in item.list" :key="i.index">{{i.index}}</span>
                    </span>
                  </span>
              </li>
              <li>
                  <span class="liLeft">作者单位:</span>
                  <span class="liRight">
                    <span v-for="(item,index) in assembleAutherUnitInfo.units" :key="item.name" style="margin-right: 10px;">{{index+1}}.{{item.name}}</span>
                  </span>
              </li>
              <li v-if="previewList.artSummary">
                  <span class="liLeft">摘要:</span>
                  <span class="liRight" v-html="previewList.artSummary"></span>
              </li>
              <li v-if="previewList.englishArtSummary">
                  <span class="liLeft">Abstract:</span>
                  <span class="liRight">{{previewList.englishArtSummary}}</span>
              </li>
              <li v-if="previewList.keyword">
                  <span class="liLeft">关键词:</span>
                  <span class="liRight">{{previewList.keyword}}</span>
              </li>
              <li v-if="previewList.englishKeyword">
                  <span class="liLeft">Keywords:</span>
                  <span class="liRight">{{previewList.englishKeyword}}</span>
              </li>
              <li v-if="previewList.periodical">
                  <span class="liLeft">刊名:</span>
                  <span class="liRight">{{previewList.periodical}}</span>
              </li>
              <li v-if="previewList.englishPeriodical">
                  <span class="liLeft">Journal:</span>
                  <span class="liRight">{{previewList.englishPeriodical}}</span>
              </li>
              <li v-if="previewList.dataStyle">
                  <span class="liLeft">数据库收录:</span>
                  <span class="liRight">{{previewList.dataStyle}}</span>
              </li>
              <li v-if="previewList.journalsYear || previewList.journalsVolume || previewList.journalsTerm">
                  <span class="liLeft">刊期:</span>
                  <span class="liRight">{{previewList.journalsYear}}年第{{previewList.journalsVolume}}卷第{{previewList.journalsTerm}}期</span>
              </li>
              <li v-if="previewList.articleColumn">
                  <span class="liLeft">栏目:</span>
                  <span class="liRight">{{previewList.articleColumn}}</span>
              </li>
              <li v-if="previewList.fundStr">
                  <span class="liLeft">基金资助:</span>
                  <span class="liRight">{{previewList.fundStr}}</span>
              </li>
              <li v-if="previewList.classifyNumber">
                  <span class="liLeft">分类号:</span>
                  <span class="liRight">{{previewList.classifyNumber}}</span>
              </li>
              <li v-if="previewList.doi">
                  <span class="liLeft">DOI:</span>
                  <span class="liRight">{{previewList.doi}}</span>
              </li>
              <li v-if="previewList.pageNumber">
                  <span class="liLeft">页数:</span>
                  <span class="liRight">{{previewList.pageNumber}}</span>
              </li>
              <li v-if="previewList.sizeNumber">
                  <span class="liLeft">页码:</span>
                  <span class="liRight">{{previewList.sizeNumber}}</span>
              </li>
          </ul>
        </div>
        <div class="centre">
          <div class="title">
            <div class="left"></div>
            <div class="content">相关文献</div>
            <div class="rights"></div>
          </div>
          <div class="list">
            <ul>
              <li v-for="item in wenxian" :key="item.id">
                <span v-html="item.title">{{item.title}}</span>  
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <div class="right">
          <p class="right-1">发布者</p>
          <p class="right-2">
            <img v-lazy="`${$global.imgUrl}${user.headImg}`" alt="">
            <span>{{user.name}}</span>
          </p>
          <div class="right-3">
            <span class="wx">
              <span style="fontSize:18px;color:#ff7d14">0</span>
              <span>文献数</span>
            </span>
            <span class="zx">
              <span style="fontSize:18px;color:#ff7d14">0</span>
              <span>资讯数</span>
            </span>
          </div>
        </div>
        <div class="right">
          <p class="right-1">期刊</p>
          <p class="right-2">
            <img src="@/assets/img/details/qikan.png" alt="">
            <span class="journalName">{{previewList.periodical}}</span>
          </p>
          <div class="right-3">
            <span class="wx">
              <span style="fontSize:18px;color:#ff7d14">0</span>
              <span>文献数</span>
            </span>
            <span class="zx">
              <span style="fontSize:18px;color:#ff7d14">0</span>
              <span>资讯数</span>
            </span>
          </div>
        </div>
        <div class="rightThree">
          <p class="right-1">作者</p>
          <p>
            <ul class="right-2">
              <li :style="{left: -left + 'px'}" v-if="previewList.firstAuthor">
                <Big width='60' height='60' size='20' :big ='previewList.firstAuthor'/>
                <div>{{previewList.firstAuthor}}</div>
                <div>第一作者</div>
              </li>
              <li :style="{left: -left + 'px'}" v-if="previewList.communicationAuthor">
                <Big width='60' height='60' size='20' :big ='previewList.communicationAuthor'/>
                <div>{{previewList.communicationAuthor}}</div>
                <div>通讯作者</div>
              </li>
              <li :style="{left: -left + 'px'}" v-for="authorName in previewList.articleAuthorList" :key="authorName.id">
                 <Big v-if="authorName.authorName" width='60' height='60' size='20' :big ='authorName.authorName'/>
                <div v-if="authorName.authorName">{{authorName.authorName}}</div>
                <div v-if="authorName.authorName">其他作者</div>
              </li>
            </ul>
          </p>
          <div class="right-3">
            <span :class="{at:indexs == index+1}" @click="paging(index + 1)" v-for="(item,index) in result" :key="index"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="images">
      <img src="@/assets/img/details/urlDisabled.png" alt="">
      <div>临时链接已失效</div>
    </div>
  </div>
</template>

<script>
export default {
  name:'paperPreview',
  components: {
    
  },
  data() {
    return {
      previewList: {},
      assembleAutherUnitInfo: {},
      user:{},
      wenxian:{},
      result:[],
      left:0, // 267 为一组,采用雪碧图类似的方式实现
      indexs: 1, 
      state:true
    };
  },
  computed:{
    // 计算出第一作者和通讯作者是否存在,及他们合在一起的数组长度
    num(){
      let i = []
      if(this.previewList.firstAuthor){
        i.push(
          {authorName:this.previewList.firstAuthor}
          )
      }
      if(this.previewList.communicationAuthor){
        i.push(
          {authorName:this.previewList.communicationAuthor}
          )
      }
      return i 
    }
  },
  created() {
    this.setPreview()
  },
  methods:{
    // 作者分页
    paging(index){
      this.indexs = index
      if(this.indexs === 1){
        this.left = 0
        return
      }
      if(this.indexs === 2){
        this.left = 267
        return
      }
      if(this.indexs === 3){
        this.left = 534
        return
      }
      if(this.indexs === 4){
        this.left = 801
        return
      }
    },
    // 获取预览详情
    async setPreview(){
      const resp = await this.$apis.userServe.articlePreview({
       articleId: this.$route.query.articleId
      });
      if(resp.resultCode == 200 ) {
        this.previewList = resp.data.data
        this.assembleAutherUnitInfo = resp.data.assembleAutherUnitInfo
        this.getAuthor()
        this.getwenxian()
      }else{
        this.state = false
      }
     let y = this.previewList.articleAuthorList.concat(this.num) // 合并两个数组,并计算长度
      for(var i=0;i<y.length;i+=3){ // 分割数组,三个对象为一个新数组并返回
          this.result.push(y.slice(i,i+3));
      }
    },
    // 获取发布者信息
    async getAuthor(){
      const resp = await this.$apis.recomendServe.getAuthor({
        userId:this.previewList.createUser,
        type:this.previewList.userType
      })
      if(resp.resultCode == 200){
        this.user = resp.content
      }
    },
    // 获取最新资讯
    async getwenxian(){
      let obj = {
        title: encodeURI(this.previewList.title),
        pageNo:1,
        pageSize:5
      }
      const { data } = await this.$apis.recomendServe.getwenxian(obj)
      this.wenxian = data.list
    }
  }
};
</script>

<style lang="scss" scoped>
.paperPreview{
  .invalid{
    margin: 0 auto 50px;
    text-align: center;
    width: 396px;
    height: 45px;
    line-height: 45px;
    background: #f9f9f9;
    border-radius: 4px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #333333;
  }
  .images{
    text-align: center;
    position: relative;
    top: 50px;
    margin-top: 50px;
    & img{
      margin-bottom: 50px;
    }
  }
  .content{
    display: flex;
    justify-content: center;
    .lift{
      margin-right: 40px;
      font-size: 13px;
      p{
        margin-bottom:44px;
        display: flex;
        flex-direction:column;
        text-align: center;
        
      }
      p img{
        margin-left: 16px;
        width: 28px;
        height: 28px;
      }
      p span{
          width: 60px !important;
      }
    }
    .centre{
      width: 905px;
      border: 1px solid #A3CBE7;
      border-radius: 10px;
      padding: 43px 25px;
      margin-bottom: 10px;
      .h{
        font-size: 30px;
        // font-weight: bold;
        line-height: 48px;
        color: #263d78;
        margin-bottom: 50px;
      }
      ul li{
          display: flex;
          margin-bottom: 10px;
          color: #333333;
      }
      .liLeft{
          display: inline-block;
          width: 90px;
      }
      .liRight{
          width: 730px;
          display: inline-block;
          word-wrap:break-word;
      }
      .title{
        width: 854px;
        height: 40px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        .left{
          width: 145px;
          height: 1px;
          background: #666;
          opacity: 0.34;
        }
        .content{
          margin: 0 45px;
        }
        .rights{
         width: 145px;
          height: 1px;
          background: #666;
          opacity: 0.34;
        }
      }
      .list {
        width: 794px;
        margin-left: 40px;
        li {
          margin-bottom: 20px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          height: 24px;
          line-height: 24px;
          list-style: outside;
          // cursor: pointer;
        }
      }
    }
    .right{
      width: 295px;
      height: 250px;
      border: 1px solid #A3CBE7;
      border-radius: 10px;
      margin-left: 10px;
      margin-bottom: 10px;
      .right-1{
        margin: 25px 0 0 20px;
      }
      .right-2{
        text-align: center;
      .journalName{
          width: 70%;
          overflow: hidden;
          margin: 0 auto;
          white-space: nowrap;
        }
        img{
          width: 84px;
          height: 84px;
          border-radius: 50px;
          
        }
        span{
          display: block;
          color: #333333;
          font-weight: bold;
          font-size: 18px;
          margin-top: 15px;
        }
      }
      .right-3{
        margin-top: 15px;
        display: flex;
        justify-content: space-around;
        font-size: 12px;
        .wx{
          text-align: center;
          display: flex;
          flex-direction:column;
        }
        .zx{
          text-align: center;
          display: flex;
          flex-direction:column;
        }
      }
    }
    .rightThree{
      width: 295px;
      height: 250px;
      border: 1px solid #A3CBE7;
      border-radius: 10px;
      margin-left: 10px;
      margin-bottom: 10px;
      .right-1{
        margin: 25px 0 0 20px;
      }
      .right-2{
        width: 295px;
        display: flex;
        text-align: center;
        margin-top: 35px;
        overflow: hidden;
        li{
          position: relative;
          margin-left: 29px;
          & div{
            line-height: 30px;
          }
        }
      }
      .right-3{
        width: 100%;
        text-align: center;
        cursor:pointer;
        span{
          display: inline-block;
          width: 15px;
          height: 7px;
          background: #464646;
          margin-top: 20px;
          margin-left: 10px;
        }
        .at{
          background: #1D52EB;
        }
      }
      img{
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
    }
  }
}
</style>
